import React from "react";
import { BarChart } from "@mui/icons-material";
import GridViewIcon from '@mui/icons-material/GridView';
import PeopleIcon from '@mui/icons-material/People';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import StreetviewIcon from '@mui/icons-material/Streetview';
import ClassIcon from '@mui/icons-material/Class';



export const schMenus = [
  {
    label: "School DashBoard",
    icon: <GridViewIcon />,
    children: [
      { label: "Total Students", icon: <BarChart /> },
      { label: "Total Teachers", icon: <BarChart /> },
      { label: "Attendance Summary", icon: <BarChart /> },
      { label: "Upcoming Exams", icon: <BarChart /> },
      { label: "Fee Collection Summary", icon: <BarChart /> },
    ],
  },
  // {
  //   label: "Users", icon: <PeopleIcon />,
  //   children: [
  //     { label: "Manage Users", icon: <BarChart /> },
  //     { label: "Roles & Permissions", icon: <BarChart /> },

  //   ],
  // },
  {
    label: "Students", icon: <PersonPinIcon />,
    children: [
      { label: "Student List", icon: <BarChart /> },
      { label: "Add Student", icon: <BarChart /> },
      { label: "Student Reports", icon: <BarChart /> },
      { label: "Last Added Student", icon: <BarChart /> },
    ],
  },

  {
    label: "Teachers", icon: <StreetviewIcon />,
    children: [
      { label: "Teacher List", icon: <BarChart /> },
      { label: "Add Teacher", icon: <BarChart /> },
      { label: "Assign Classes/Subjects", icon: <BarChart /> },
         ],
  },

 {
    label: "Classes", icon: <ClassIcon />,
    children: [
      { label: "Class List", icon: <BarChart /> },
      { label: "Add Class", icon: <BarChart /> },
      { label: "Class-wise Students", icon: <BarChart /> },
         ],
  },

 {
    label: "Subjects", icon: <BarChart />,
    children: [
      { label: "Subjects List", icon: <BarChart /> },
      { label: "Add Subject", icon: <BarChart /> },
      
      
         ],
  },

 {
    label: "Exams", icon: <BarChart />,
    children: [
      { label: "Exam List", icon: <BarChart /> },
      { label: "Add Exam", icon: <BarChart /> },
      { label: "Exam Results", icon: <BarChart /> },
         ],
  },


 {
    label: "Attendance", icon: <BarChart />,
    children: [
      { label: "Teacher List", icon: <BarChart /> },
       { label: "Add Attendance", icon: <BarChart /> },
        { label: "Attendance Report", icon: <BarChart /> },
         ],
  },


   {
    label: "Fees", icon: <BarChart />, divider: true,
    children: [
      { label: "Fee Structure", icon: <BarChart /> },
      { label: "Student Payments", icon: <BarChart /> },
      { label: "Invoices / Receipts", icon: <BarChart /> },
         ],
  },

 {
    label: "Reports & Dashboard", icon: <BarChart />,
    children: [
      { label: "Student Reports", icon: <BarChart /> },
      { label: "Teacher Reports", icon: <BarChart /> },
      { label: "Exam Performance", icon: <BarChart /> },
      { label: "Attendance Reports", icon: <BarChart /> },
      { label: "Fee Reports", icon: <BarChart /> },
         ],
  },
 {
    label: "Software Settings", icon: <BarChart />, divider: true,
    children: [
      { label: "School Settings", icon: <BarChart /> },
      { label: "User Settings", icon: <BarChart /> },
      { label: "Backup / Restore", icon: <BarChart />, },
         ],
  },


];

